import * as types from './types';

export const setDesktopNavigation = (payload) => (dispatch) => (
  dispatch({
    type: types.NAVIGATION_SET_DESKTOP,
    payload
  })
);

export const setMobileNavigation = (payload) => (dispatch) => (
  dispatch({
    type: types.NAVIGATION_SET_MOBILE,
    payload
  })
);

export const setDesktopNavigationVariation = (payload) => (dispatch) => (
  dispatch({
    // eslint-disable-next-line import/namespace
    type: types.NAVIGATION_SET_DESKTOP_VARIATION,
    payload
  })
);
